import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import HtmlPart from '../../parts/HtmlPart';
import TextCTA from '../../layout/buttons/TextCTA';
import CardTitlePart from '../../parts/CardTitlePart';
import Basket from '../../parts/Basket/';

// actions
import { confirmOrder } from '../../actions/orders';


class _CancelledOrderCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      confirmed: false
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  handleConfirm() {
    this.props.confirmOrder(this.props.id, this.props.orderRef, this.props.orderIdx);
    this.setState({
      confirmed: true
    });
  }

  toggleExpand() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { total, items, balance, deposit, orderRef, orderNo, title,
      bodyText, expandButtonText, hideButtonText } = this.props;
    const { expanded } = this.state;

    const basketHeight = expanded ? '2000px' : '28vh';

    return (
      <div>

        <CardTitlePart title={title} />

        <div style={{ maxHeight: basketHeight, overflow: 'hidden' }} className="basket-wrap u-padding-small u-pale-grey-bg">

          <Basket
            items={items}
            total={total}
            deposit={deposit}
            balance={balance}
          />

          <div className="u-padding-tiny u-padding-top-small u-text-center c-event-feed__card__extra-info">
            <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
          </div>

        </div>

        <div className="u-clearfix c-event-feed__card__splitter u-flex-justify-end">
          <TextCTA
            text={expanded ? hideButtonText : expandButtonText}
            position={'right'}
            align={'right'}
            type={expanded ? 'shrink' : 'expand'}
            onBtnClick={this.toggleExpand}
          />
        </div>

        <div className="u-padding-small">
          <HtmlPart htmlString={bodyText} />
        </div>
      </div>
    );
  }
}


const mapDispatchToProps = dispatch => bindActionCreators({
  confirmOrder
}, dispatch);
export default connect(null, mapDispatchToProps)(_CancelledOrderCard);



// WEBPACK FOOTER //
// ./src/cards/templates/CancelledOrderCard.js